import { PageTitleStyles } from "./styles";

export default function PageTitle({children, ta, m}) {
    return (
        <PageTitleStyles ta={ta} m={m} >
            {children}
        </PageTitleStyles>
    )
}